module.exports = __webpack_public_path__ + "assets/img/36_1505.4aab8a91.jpg";